import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserTournament } from '../../../../../models/users/user-tournament.model';
import { UserTournamentsResultsResponse } from '../../../../../models/users/responses/api-users-tournaments-results-response.model';
import { ApiUsersService } from '../../../../../services/users/api/api-users.service';
import { AlertsService } from '../../../../../services/alerts.service';
import { DateService } from '../../../../../services/date.service';

@Component({
  selector: 'app-user-tournaments-tab',
  templateUrl: './user-tournaments-tab.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class UserTournamentsTabComponent {

  @Input() userId: number = 0;

  isLoading: boolean = false;

  expandedMatchs = new Set<number>();
  toggleMatchs(tournamentId: number): void { this.expandedMatchs.has(tournamentId) ? this.expandedMatchs.delete(tournamentId) : this.expandedMatchs.add(tournamentId); }

  tournaments: UserTournament[] = [];
  resultsPerPage: number = 25;
  pageNumber: number = 1;
  totalResults: number = 0;

  get totalPages(): number {
    return Math.ceil(this.totalResults / this.resultsPerPage);
  }

  getPageNumbers(): (number | null)[] {
    const total = this.totalPages;
    const current = this.pageNumber;

    const visibleSet = new Set<number>();
    for (let i = 1; i <= Math.min(2, total); i++) visibleSet.add(i);
    for (let i = Math.max(total - 1, 1); i <= total; i++) visibleSet.add(i);
    for (let i = Math.max(1, current - 2); i <= Math.min(total, current + 2); i++) visibleSet.add(i);

    const sorted = Array.from(visibleSet).sort((a, b) => a - b);

    const result: (number | null)[] = [];
    for (let i = 0; i < sorted.length; i++) {
      if (i > 0 && sorted[i] - sorted[i - 1] > 1) result.push(null);
      result.push(sorted[i]);
    }

    return result;
  }

  goToPage(page: number): void {
    this.pageNumber = page;
    this.refreshTournamentsList();
  }

  constructor(public dateService: DateService, private apiUsersService: ApiUsersService, private alertsService: AlertsService) {}

  load(): void {
    this.pageNumber = 1;
    this.refreshTournamentsList();
  }

  onClickPaginationPrevious(): void {
    this.pageNumber--;
    this.refreshTournamentsList();
  }

  onClickPaginationNext(): void {
    this.pageNumber++;
    this.refreshTournamentsList();
  }

  private refreshTournamentsList(): void {
    this.isLoading = true;
    this.expandedMatchs.clear();

    this.apiUsersService.getUserTournaments(this.userId, this.pageNumber, this.resultsPerPage).then(
      (response: UserTournamentsResultsResponse) => {
        this.isLoading = false;
        this.tournaments = response.results;
        this.totalResults = response.resultsTotal;
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error loading tournaments (' + error + ')');
      }
    );
  }
}
